import { Box, Center, Group, Stack, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { IconFigmaEuro, IconFigmaShieldCheck, IconFigmaZap } from '@/assets/icons';

const trustItems = [
  { icon: IconFigmaShieldCheck, key: 'auth.trust.ssl' },
  { icon: IconFigmaZap, key: 'auth.trust.realtime' },
  { icon: IconFigmaEuro, key: 'auth.trust.billing' }
] as const;

export const LoginHero = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width: 62em)');

  return (
    <Box
      w={{ base: '100%', md: 440 }}
      p={isDesktop ? 40 : 0}
      style={
        isDesktop
          ? {
              borderRadius: 12,
              backgroundColor: 'var(--color-bg-surface-2)',
              border: '1px solid var(--color-border-soft)'
            }
          : undefined
      }
    >
      <Stack gap="lg">
        <Stack gap={isDesktop ? 'lg' : 6}>
          <Title
            order={1}
            fz={{ base: 24, md: 34 }}
            lh={{ base: 1.25, md: 1.2 }}
            fw={700}
            style={{ color: 'var(--color-text-primary)' }}
          >
            {t('auth.title')}
          </Title>
          <Text fz={isDesktop ? 14 : 13} style={{ color: 'var(--color-text-secondary)' }}>
            {t('auth.subtitle')}
          </Text>
        </Stack>

        <Stack gap={isDesktop ? 14 : 8}>
          {trustItems.map(({ icon: Icon, key }) => (
            <Group key={key} gap={isDesktop ? 12 : 10} wrap="nowrap">
              <Center
                w={isDesktop ? 32 : 26}
                h={isDesktop ? 32 : 26}
                style={{
                  borderRadius: 6,
                  backgroundColor: 'var(--color-bg-surface-2)',
                  border: '1px solid var(--color-border-default)',
                  color: 'var(--color-text-secondary)'
                }}
              >
                <Icon size={isDesktop ? 16 : 13} />
              </Center>
              <Text fz={isDesktop ? 14 : 12.5} style={{ color: 'var(--color-text-secondary)' }}>
                {t(key)}
              </Text>
            </Group>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
